export const getBaseApiUrl = () =>
  window.location.hostname === "localhost"
    ? "http://localhost:3002/"
    : "http://whssportshub.in/";
